import axiosInstance from 'app/modules/shared/api/axiosInstance';
import { LanguageValues } from 'app/modules/shared/hooks/useLanguageChange/useLanguageChange.types';
import { switchLanguageResponse } from './LanguageSwitcherAPI.types';
export const LanguageSwitcherAPI = {
    // this endpoint change both system language and data language
    switchLanguage: (
        company: string,
        factory: string,
        id: string,
        languages: Lowercase<LanguageValues>,
    ) =>
        axiosInstance.patch<switchLanguageResponse>(
            `v2/${company}/${factory}/users/${id}/languages`,
            {
                languages,
            },
        ),
};
